module.exports = __webpack_public_path__ + "media/images/icon_arrow_lightgreen-7ba20eb11998f8fe0d7ec28bc111f678.svg";